import React, { useState } from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {
  Alert,
  AlertColor,
  Box,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';

import { getClientUrls } from '@paragon/login-tools';

import { useAppSelector } from '../hooks';

export interface PermanentLinkProps {
  readonly stationGuid: string;
  readonly token: string;
}

export function NewPermanentLink({ stationGuid, token }: PermanentLinkProps) {
  const stationsState = useAppSelector((state) => state.stations);
  const clientUrls = useAppSelector(getClientUrls);
  const [alert, setAlert] = useState<{ type: AlertColor; message: string } | null>(null);

  const url = `${clientUrls.designUrl}?station=${stationGuid}&jwt=${token}`;
  const stationName = stationsState.stations[stationGuid].name;

  function copyUrl() {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        setAlert({ type: 'success', message: 'Permanent Link copied to your clipboard.' });
      })
      .catch(() => {
        setAlert({
          type: 'error',
          message: 'Unable to access clipboard in your browser.  Select the URL in the box and copy it manually.',
        });
      });
  }

  return (
    <Box sx={{ minWidth: 400 }}>
      <Paper sx={{ padding: 2, marginBottom: 3 }}>
        <Typography>
          This is a permanent link which grants access to station &apos;{stationName}&apos;, even without logging in. Do
          not share it with anyone outside your organization.
        </Typography>
      </Paper>

      <TextField
        label="Permanent link"
        value={url}
        fullWidth
        sx={{ marginBottom: 1 }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <Tooltip disableInteractive title="Copy to clipboard" placement="top">
                  <IconButton onClick={copyUrl}>
                    <ContentCopyIcon />
                  </IconButton>
                </Tooltip>
              </InputAdornment>
            ),
          },
        }}
        onFocus={(event) => event.target.select()}
      />

      {alert && (
        <Alert variant="outlined" severity={alert.type}>
          {alert.message}
        </Alert>
      )}
    </Box>
  );
}
